export const tooltipTrigger = 'axis'
export const tooltipPosition = 'top'

export const tooltipStyle = {
  backgroundColor: '#ffffff',
  borderColor: '#e0e0e0',
  borderWidth: 1,
  extraCssText: 'box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);',
  textStyle: {
    color: '#333333',
  },
}

export const axisPointerStyle = {
  type: 'line',
  axis: 'y',
  snap: true,
  lineStyle: {
    color: '#5f38f9',
    width: 1,
  },
}

export const colorSquare = () => {
  return `<span style="display: inline-block; width: 10px; height: 10px; background-color: #28a745; margin-right: 5px;"></span>`
}
